import { DynamicIcon } from "lucide-react/dynamic";
import { ComponentPropsWithRef } from "react";
import { twMerge } from "tailwind-merge";

export const IconCircle = ({
  icon,
  className,
}: {
  icon: ComponentPropsWithRef<typeof DynamicIcon>["name"];
  className?: string;
}) => {
  return (
    <div
      className={twMerge(
        "bg-theme-primary/20 outline-theme-primary/30 inline-flex items-center justify-center gap-2.5 rounded-full p-3.5 outline-2 -outline-offset-2",
        className,
      )}
    >
      <div className="relative size-8 overflow-hidden">
        <DynamicIcon name={icon} size={32} className="text-theme-active" />
      </div>
    </div>
  );
};
